import React from 'react';

import { useFormContext } from 'react-hook-form';
import { Button, LbInput, LbSelect } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import {
  GridTableCell,
  GridTableRow,
} from '../../../../shared/components/table-components';

import { HiddenInput } from '../../../../shared/components/form-components';
import { EntityListFormValues } from '../../../interfaces/entity-list/EntityListFilters';
import { inbodyTypeOptionsWithAll } from '../../../../shared/constants/inbody-info/InbodyType';
import { entityStatusOption } from '../../../constants/entityStatus';
import { entityListStore } from '../../../stores/entityListStore';
import { ListMode, LIST_MODE } from '../NgzEntityList.settings';

type FilterRowProps = {
  listMode: ListMode;
};

const FilterRow = observer(({ listMode }: FilterRowProps) => {
  const { control, register, reset } = useFormContext<EntityListFormValues>();
  const {
    filterMethods: { defaultFilterData, filterData },
  } = entityListStore;

  const handleReset = () => {
    // Keep paymentFlowType and solutions values, to not reset selected tab in EntityListFilterTabs
    // solutionModeType is automatically set from defaultFilterData based on listMode
    reset({
      ...defaultFilterData,
      paymentFlowType: filterData.paymentFlowType,
      solutions: filterData.solutions,
    });
  };

  const inputGeneralProps = { control, variant: 'outlined', size: 'small' } as const;

  return (
    <GridTableRow variant="filter" component="form">
      <HiddenInput register={register} name="solutionModeType" />
      <LbInput
        {...inputGeneralProps}
        name="businessName"
        placeholder="Name"
        dataTestId="business-name-input"
      />
      <LbSelect
        {...inputGeneralProps}
        name="inbodyType"
        options={inbodyTypeOptionsWithAll}
        displayEmpty
        dataTestId="inbody-type-select"
      />
      <LbInput
        {...inputGeneralProps}
        name="ownerName"
        placeholder="Name"
        dataTestId="owner-name-input"
      />
      {listMode === LIST_MODE.NUTRITION && (
        <LbSelect
          {...inputGeneralProps}
          name="status"
          options={entityStatusOption}
          displayEmpty
          dataTestId="status-select"
        />
      )}
      {listMode === LIST_MODE.SCAN_IQ && (
        <LbSelect
          {...inputGeneralProps}
          name="scanIqStatus"
          options={entityStatusOption}
          displayEmpty
          dataTestId="scan-iq-status-select"
        />
      )}
      <div />
      <div />
      <GridTableCell justify="stretch">
        <Button
          variant="outlined"
          size="small"
          type="reset"
          fullWidth
          onClick={handleReset}
        >
          Clear All
        </Button>
      </GridTableCell>
    </GridTableRow>
  );
});

export { FilterRow };
